import React from 'react'
import { useTranslation } from 'react-i18next'

import cs from '../i18n/cs.json'
import en from '../i18n/en.json'

import { Mode } from '../enums'
import ModeElement from './ModeElements'
import { DisableDates } from '../Datepicker'

interface IProps {
  disableDates?: DisableDates
  disableInModes: Mode[]
  selectedDate: Date
  showCurrentDay?: boolean
  onSelectMonth?: (month: number) => void
}

const ModeMonths = (props: IProps) => {
  const { t, i18n } = useTranslation('ModeMonth')
  i18n.addResourceBundle('cs', 'ModeMonth', cs)
  i18n.addResourceBundle('en', 'ModeMonth', en)

  const months = [
    t('01'),
    t('02'),
    t('03'),
    t('04'),
    t('05'),
    t('06'),
    t('07'),
    t('08'),
    t('09'),
    t('10'),
    t('11'),
    t('12')
  ]

  return (
    <div className='cs-rdatepicker__mode-content'>
      <table className='space-cols'>
        <ModeElement
          mode={Mode.Month}
          values={months}
          selectedDate={props.selectedDate}
          columns={3}
          disableDates={props.disableDates}
          disableFull={props.disableInModes.indexOf(Mode.Month) !== -1}
          onClick={(index: number) => props.onSelectMonth && props.onSelectMonth(index)}
        />
      </table>
    </div>
  )
}

export default ModeMonths
